import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import SubjectItemsList from 'modules/documents/components/SubjectItemList/SubjectItemsList';

import { useDocuments } from 'modules/documents/hooks';

const DocumentsPage = () => {
  const { courseId, subjectId } = useParams<{ courseId: string; subjectId: string }>();
  const { documents, loading } = useDocuments({ courseId, subjectId });
  const intl = useIntl();

  const onSelectDocument = useCallback((document: any) => {
    // eslint-disable-next-line no-undef
    window.open(document.url, document.name);
  }, []);

  const getName = (document: any) => document?.name;

  return (
    <SubjectItemsList
      getName={getName}
      items={documents}
      loading={loading}
      onSelectItem={onSelectDocument}
      noItemsMessage={intl.formatMessage({ id: 'noDocumentsInSubject' })}
    />
  );
};

export default DocumentsPage;
